'use strict';

/**
 * Upcoming tour list requires us to retrieve all products.  We can't build the list on the backend 
 * because there can be more than 50 items in the product list.  
 */

var BD = window.BD = window.BD || {};
BD.Upcoming = (function($) {
  var $upcomingContainer;
  const sixteenHoursInMs = 57600 * 1000;

  function getAllUpcoming($tours) {
    var dateRe = /[0-9]{8}/;

    return $tours.filter((idx, el) => {
      var ymd = '' + el.dataset['tourYmd'];
      
      if (!ymd || !ymd.match(dateRe)) { return false; }

      var intVal = parseInt(ymd);
      if (!intVal || isNaN(intVal)) { return false; }
      
      const date = ymd.substring(0, 4) + '-' + ymd.substring(4, 6) + '-' + ymd.substring(6, 8);
      
      // Continue to show "upcoming" until 4pm on the same day.
      return (Date.parse(date) + sixteenHoursInMs) > Date.now();
    });
    
  }
  
  function showUpcoming($tours) {
    var tours = getAllUpcoming($tours).get();
    
    tours = tours.sort((a, b) => {
      var ymdA = parseInt(a.dataset['tourYmd']);
      var ymdB = parseInt(b.dataset['tourYmd']);
      return ymdA - ymdB;
    });
    
    const upcomingTours = tours.slice(0, 3);
    
    $upcomingContainer.empty();
    upcomingTours.forEach(e => {
      const $div = $('<div class="col col-33"></div>').appendTo($upcomingContainer);
      $(e).clone().appendTo($div);
    });
  }
  
  function init() {
    // We use the tour browser data to load upcoming tours
    BD.TourBrowser.init();
    $upcomingContainer = $('#section--upcoming-tours .grid-ui');
    BD.TourBrowser.onLoadingComplete(showUpcoming);
  }
  
  return { init }
})(jQuery)